module.exports = __webpack_public_path__ + "assets/img/21_802_big.6c2b4abe.jpg";